/**
 * 检查渠道类型工具方法
 * 根据teamId判断是官网渠道还是混服渠道
 * @param {string} teamId - 用户的teamId
 * @returns {string} 渠道类型标识
 */
export function checkChannelType(teamId) {
  // console.log(teamId);
  // return ''
  if (!teamId) {
    console.warn('checkChannelType: teamId is required');
    return 'SGW_double11_prd_2'; // 默认返回官网渠道
  }

  // 以"2"开头的teamId属于混服渠道，其他属于官网渠道
  if (/^2/.test(teamId)) {
    return 'SLY_double11_prd_2'; // 混服渠道
  } else {
    return 'SGW_double11_prd_2'; // 官网渠道
  }
}
